
Object.defineProperty(exports, "__esModule", { value: true });

const {
  Decimal,
  objectEnumValues,
  makeStrictEnum,
  Public,
  getRuntime,
} = require('./runtime/index-browser.js')


const Prisma = {}

exports.Prisma = Prisma
exports.$Enums = {}

/**
 * Prisma Client JS version: 5.17.0
 * Query Engine version: 393aa359c9ad4a4bb28630fb5613f9c281cde053
 */
Prisma.prismaVersion = {
  client: "5.17.0",
  engine: "393aa359c9ad4a4bb28630fb5613f9c281cde053"
}

Prisma.PrismaClientKnownRequestError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientKnownRequestError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)};
Prisma.PrismaClientUnknownRequestError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientUnknownRequestError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.PrismaClientRustPanicError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientRustPanicError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.PrismaClientInitializationError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientInitializationError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.PrismaClientValidationError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientValidationError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.NotFoundError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`NotFoundError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.Decimal = Decimal

/**
 * Re-export of sql-template-tag
 */
Prisma.sql = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`sqltag is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.empty = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`empty is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.join = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`join is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.raw = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`raw is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.validator = Public.validator

/**
* Extensions
*/
Prisma.getExtensionContext = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`Extensions.getExtensionContext is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.defineExtension = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`Extensions.defineExtension is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}

/**
 * Shorthand utilities for JSON filtering
 */
Prisma.DbNull = objectEnumValues.instances.DbNull
Prisma.JsonNull = objectEnumValues.instances.JsonNull
Prisma.AnyNull = objectEnumValues.instances.AnyNull

Prisma.NullTypes = {
  DbNull: objectEnumValues.classes.DbNull,
  JsonNull: objectEnumValues.classes.JsonNull,
  AnyNull: objectEnumValues.classes.AnyNull
}

/**
 * Enums
 */

exports.Prisma.TransactionIsolationLevel = makeStrictEnum({
  ReadUncommitted: 'ReadUncommitted',
  ReadCommitted: 'ReadCommitted',
  RepeatableRead: 'RepeatableRead',
  Serializable: 'Serializable'
});

exports.Prisma.UserScalarFieldEnum = {
  id: 'id',
  cognitoSub: 'cognitoSub',
  isRegistered: 'isRegistered',
  temporaryToken: 'temporaryToken',
  createdAt: 'createdAt',
  lastActiveDiseaseId: 'lastActiveDiseaseId',
  lastActiveOrganisationId: 'lastActiveOrganisationId'
};

exports.Prisma.AuthLogScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  processId: 'processId',
  cognitoSub: 'cognitoSub',
  userId: 'userId',
  email: 'email',
  lambdaName: 'lambdaName',
  triggerSource: 'triggerSource',
  state: 'state',
  processingTime: 'processingTime',
  parsedUserAgent: 'parsedUserAgent',
  event: 'event',
  failureReason: 'failureReason'
};

exports.Prisma.UserActivityLogScalarFieldEnum = {
  id: 'id',
  type: 'type',
  info: 'info',
  userId: 'userId',
  path: 'path',
  userAgent: 'userAgent',
  timestamp: 'timestamp'
};

exports.Prisma.UserAttributesScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  finishedSignUp: 'finishedSignUp',
  finishedSignUpViaCall: 'finishedSignUpViaCall',
  language: 'language',
  dateOfBirth: 'dateOfBirth',
  watchedOnboardingVideo: 'watchedOnboardingVideo',
  hasSeenAllCards: 'hasSeenAllCards',
  gender: 'gender',
  education: 'education',
  ethnicity: 'ethnicity',
  migrationBackground: 'migrationBackground',
  country: 'country',
  city: 'city',
  address: 'address',
  postalCode: 'postalCode',
  acquisitionSource: 'acquisitionSource',
  acquisitionDetail: 'acquisitionDetail',
  utmSource: 'utmSource',
  utmCampaign: 'utmCampaign',
  utmContent: 'utmContent',
  utmMedium: 'utmMedium',
  utmTerm: 'utmTerm',
  placement: 'placement',
  matchtype: 'matchtype',
  campaignId: 'campaignId',
  adgroupId: 'adgroupId',
  adId: 'adId',
  fbclid: 'fbclid',
  gclid: 'gclid',
  isTestUser: 'isTestUser',
  opadePatientId: 'opadePatientId',
  hometown: 'hometown',
  currentTown: 'currentTown',
  occupation: 'occupation',
  introduction: 'introduction',
  avatarUrl: 'avatarUrl',
  lookingForOnMamaHealth: 'lookingForOnMamaHealth',
  lookingForOthersOnMamaHealth: 'lookingForOthersOnMamaHealth',
  agreedToEndoStudyInformation20240115: 'agreedToEndoStudyInformation20240115',
  agreedToPrivacyPolicy20231018: 'agreedToPrivacyPolicy20231018',
  agreedToTermsAndConditions20230830: 'agreedToTermsAndConditions20230830',
  name: 'name',
  email: 'email',
  telephone: 'telephone'
};

exports.Prisma.DiseaseSettingsScalarFieldEnum = {
  id: 'id',
  name: 'name',
  stripeId: 'stripeId'
};

exports.Prisma.OrganisationSettingsScalarFieldEnum = {
  id: 'id',
  name: 'name',
  stripeId: 'stripeId',
  diseaseId: 'diseaseId',
  createdAt: 'createdAt'
};

exports.Prisma.GroupsOfUserScalarFieldEnum = {
  id: 'id',
  groups: 'groups',
  createdAt: 'createdAt',
  userId: 'userId',
  diseaseId: 'diseaseId',
  organisationId: 'organisationId'
};

exports.Prisma.UserFeedbackScalarFieldEnum = {
  feedbackId: 'feedbackId',
  title: 'title',
  type: 'type',
  state: 'state',
  feedback: 'feedback',
  activityMinutes: 'activityMinutes',
  timestamp: 'timestamp',
  userId: 'userId'
};

exports.Prisma.StripeInfoScalarFieldEnum = {
  id: 'id',
  customerId: 'customerId',
  userId: 'userId',
  diseaseId: 'diseaseId',
  organisationId: 'organisationId'
};

exports.Prisma.UserDetailScalarFieldEnum = {
  id: 'id',
  type: 'type',
  text: 'text',
  number: 'number',
  unit: 'unit',
  select: 'select',
  parentDetailId: 'parentDetailId',
  inputTime: 'inputTime',
  userId: 'userId',
  diseaseId: 'diseaseId'
};

exports.Prisma.ConversationScalarFieldEnum = {
  id: 'id',
  inputTime: 'inputTime',
  type: 'type',
  userId: 'userId',
  diseaseId: 'diseaseId',
  questionnaireGraphId: 'questionnaireGraphId'
};

exports.Prisma.MessageScalarFieldEnum = {
  id: 'id',
  inputTime: 'inputTime',
  role: 'role',
  content: 'content',
  conversationId: 'conversationId',
  hasMedicationMentioned: 'hasMedicationMentioned',
  contentLocalized: 'contentLocalized',
  language: 'language',
  questionNodeId: 'questionNodeId'
};

exports.Prisma.UserMediaScalarFieldEnum = {
  id: 'id',
  mainType: 'mainType',
  subtype: 'subtype',
  extractedText: 'extractedText',
  path: 'path',
  messageId: 'messageId',
  createdAt: 'createdAt',
  documentExtractionId: 'documentExtractionId',
  duration: 'duration'
};

exports.Prisma.DocumentExtractionScalarFieldEnum = {
  id: 'id',
  documentLabel: 'documentLabel',
  documentQuality: 'documentQuality',
  documentSummary: 'documentSummary'
};

exports.Prisma.NotificationScalarFieldEnum = {
  id: 'id',
  type: 'type',
  userId: 'userId',
  whatsAppMessageIds: 'whatsAppMessageIds',
  hasError: 'hasError',
  title: 'title',
  frequency: 'frequency',
  messageTitle: 'messageTitle',
  message: 'message',
  sendAt: 'sendAt',
  attemptsPerScheduleCycle: 'attemptsPerScheduleCycle',
  language: 'language'
};

exports.Prisma.PygrationsScalarFieldEnum = {
  id: 'id',
  handle: 'handle',
  description: 'description',
  executedAt: 'executedAt',
  executeNext: 'executeNext',
  lastRunSuccessful: 'lastRunSuccessful',
  type: 'type'
};

exports.Prisma.QuestionnaireGraphScalarFieldEnum = {
  id: 'id',
  version: 'version',
  createdAt: 'createdAt',
  diseaseId: 'diseaseId'
};

exports.Prisma.EmbeddingScalarFieldEnum = {
  id: 'id',
  prior: 'prior',
  questionNodeId: 'questionNodeId',
  questionnaireGraphId: 'questionnaireGraphId'
};

exports.Prisma.QuestionNodeScalarFieldEnum = {
  id: 'id',
  nodeId: 'nodeId',
  type: 'type',
  subtype: 'subtype',
  question: 'question',
  phraseKey: 'phraseKey',
  informationNeeded: 'informationNeeded',
  choices: 'choices',
  isMedical: 'isMedical',
  shouldExplore: 'shouldExplore',
  loopThreshold: 'loopThreshold',
  mediaSrc: 'mediaSrc',
  mediaAlt: 'mediaAlt',
  questionnaireGraphId: 'questionnaireGraphId'
};

exports.Prisma.FollowUpEdgeScalarFieldEnum = {
  id: 'id',
  sourceNodeId: 'sourceNodeId',
  targetNodeId: 'targetNodeId',
  questionnaireGraphId: 'questionnaireGraphId'
};

exports.Prisma.QuestionVisitScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  nodeId: 'nodeId',
  questionNodeId: 'questionNodeId',
  status: 'status',
  nodeResponseSummary: 'nodeResponseSummary',
  questionnaireStateId: 'questionnaireStateId',
  assistantMessageId: 'assistantMessageId',
  userMessageId: 'userMessageId'
};

exports.Prisma.QuestionnaireStateScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  currentNodeId: 'currentNodeId',
  conversationId: 'conversationId'
};

exports.Prisma.LiveCheckScalarFieldEnum = {
  id: 'id',
  type: 'type',
  step: 'step',
  success: 'success',
  testCase: 'testCase',
  duration: 'duration',
  errorMessage: 'errorMessage',
  createdAt: 'createdAt'
};

exports.Prisma.ReportScalarFieldEnum = {
  id: 'id',
  conversationId: 'conversationId',
  reportContent: 'reportContent',
  createdAt: 'createdAt',
  questionNodeId: 'questionNodeId',
  userId: 'userId'
};

exports.Prisma.AgentOutputLogScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  messageId: 'messageId',
  conversationId: 'conversationId',
  event: 'event'
};

exports.Prisma.MessageMetadataScalarFieldEnum = {
  id: 'id',
  messageId: 'messageId',
  sources: 'sources',
  createdAt: 'createdAt'
};

exports.Prisma.SortOrder = {
  asc: 'asc',
  desc: 'desc'
};

exports.Prisma.NullableJsonNullValueInput = {
  DbNull: Prisma.DbNull,
  JsonNull: Prisma.JsonNull
};

exports.Prisma.QueryMode = {
  default: 'default',
  insensitive: 'insensitive'
};

exports.Prisma.NullsOrder = {
  first: 'first',
  last: 'last'
};

exports.Prisma.JsonNullValueFilter = {
  DbNull: Prisma.DbNull,
  JsonNull: Prisma.JsonNull,
  AnyNull: Prisma.AnyNull
};
exports.UserActivityLogType = exports.$Enums.UserActivityLogType = {
  EVENT: 'EVENT',
  ACTIVITY: 'ACTIVITY'
};

exports.Gender = exports.$Enums.Gender = {
  MALE: 'MALE',
  FEMALE: 'FEMALE',
  INTERSEX: 'INTERSEX'
};

exports.UserGroup = exports.$Enums.UserGroup = {
  USER: 'USER',
  ADMIN: 'ADMIN',
  MEMBER: 'MEMBER',
  PAG: 'PAG',
  PHARMA: 'PHARMA',
  PHARMA_DEMO: 'PHARMA_DEMO'
};

exports.UserFeedbackType = exports.$Enums.UserFeedbackType = {
  RATING: 'RATING',
  SCALE: 'SCALE',
  SATISFACTION: 'SATISFACTION'
};

exports.UserFeedbackState = exports.$Enums.UserFeedbackState = {
  RATED: 'RATED',
  UNRATED: 'UNRATED',
  UNSEEN: 'UNSEEN'
};

exports.ConversationType = exports.$Enums.ConversationType = {
  RETROSPECTIVE: 'RETROSPECTIVE',
  ANSWER: 'ANSWER'
};

exports.Role = exports.$Enums.Role = {
  SYSTEM: 'SYSTEM',
  USER: 'USER',
  ASSISTANT: 'ASSISTANT'
};

exports.NotificationType = exports.$Enums.NotificationType = {
  RECURRING: 'RECURRING',
  NON_RECURRING: 'NON_RECURRING'
};

exports.JobType = exports.$Enums.JobType = {
  MULTI: 'MULTI',
  SINGLE: 'SINGLE'
};

exports.NodeType = exports.$Enums.NodeType = {
  SIGNUP: 'SIGNUP',
  APPROVAL: 'APPROVAL',
  MODAL: 'MODAL',
  QUESTION: 'QUESTION',
  REGEX: 'REGEX',
  TEXT: 'TEXT',
  DYNAMIC: 'DYNAMIC',
  SINGLE_CHOICE: 'SINGLE_CHOICE',
  SINGLE_ENUM: 'SINGLE_ENUM',
  MULTIPLE_CHOICE: 'MULTIPLE_CHOICE',
  MULTIPLE_CHOICE_OTHER: 'MULTIPLE_CHOICE_OTHER',
  MULTIPLE_ENUM: 'MULTIPLE_ENUM',
  SCALE: 'SCALE',
  AUXILIARY: 'AUXILIARY'
};

exports.Subtype = exports.$Enums.Subtype = {
  NAME: 'NAME',
  POSTAL_CODE: 'POSTAL_CODE',
  MARKETING_CHANNEL: 'MARKETING_CHANNEL',
  OCCUPATION: 'OCCUPATION',
  MIGRATION_BACKGROUND: 'MIGRATION_BACKGROUND',
  GOALS: 'GOALS',
  PHONE: 'PHONE',
  OPADE_STUDY_ID: 'OPADE_STUDY_ID',
  YEAR_OF_BIRTH: 'YEAR_OF_BIRTH',
  INTRODUCTION: 'INTRODUCTION',
  COUNTRY: 'COUNTRY',
  PAG: 'PAG',
  ACKNOWLEDGE: 'ACKNOWLEDGE',
  TERMS: 'TERMS',
  ENDO_STUDY_AGREEMENT: 'ENDO_STUDY_AGREEMENT',
  LINK: 'LINK',
  MEDIA: 'MEDIA',
  GENDER: 'GENDER',
  ETHNICITY: 'ETHNICITY',
  EDUCATION: 'EDUCATION',
  DIAGNOSIS: 'DIAGNOSIS',
  INSURANCE: 'INSURANCE',
  PROFESSION: 'PROFESSION',
  SYMPTOM_DURATION: 'SYMPTOM_DURATION',
  OPTIONAL_MONTH_YEAR: 'OPTIONAL_MONTH_YEAR',
  ZERO_TO_TEN: 'ZERO_TO_TEN',
  SYMPTOMS: 'SYMPTOMS',
  TREATMENTS: 'TREATMENTS',
  CHALLENGES: 'CHALLENGES',
  FINAL: 'FINAL',
  EMAIL: 'EMAIL',
  EMAIL_NAME_TERMS: 'EMAIL_NAME_TERMS'
};

exports.QuestionStatus = exports.$Enums.QuestionStatus = {
  COMPLETE: 'COMPLETE',
  OPEN: 'OPEN',
  PARTIAL: 'PARTIAL',
  IRRELEVANT: 'IRRELEVANT',
  LOOP_SKIPPED: 'LOOP_SKIPPED',
  SKIPPED: 'SKIPPED',
  EXPLORATION: 'EXPLORATION'
};

exports.LiveCheckType = exports.$Enums.LiveCheckType = {
  FRONTEND_APP: 'FRONTEND_APP'
};

exports.Prisma.ModelName = {
  User: 'User',
  AuthLog: 'AuthLog',
  UserActivityLog: 'UserActivityLog',
  UserAttributes: 'UserAttributes',
  DiseaseSettings: 'DiseaseSettings',
  OrganisationSettings: 'OrganisationSettings',
  GroupsOfUser: 'GroupsOfUser',
  UserFeedback: 'UserFeedback',
  StripeInfo: 'StripeInfo',
  UserDetail: 'UserDetail',
  Conversation: 'Conversation',
  Message: 'Message',
  UserMedia: 'UserMedia',
  DocumentExtraction: 'DocumentExtraction',
  Notification: 'Notification',
  Pygrations: 'Pygrations',
  QuestionnaireGraph: 'QuestionnaireGraph',
  Embedding: 'Embedding',
  QuestionNode: 'QuestionNode',
  FollowUpEdge: 'FollowUpEdge',
  QuestionVisit: 'QuestionVisit',
  QuestionnaireState: 'QuestionnaireState',
  LiveCheck: 'LiveCheck',
  Report: 'Report',
  AgentOutputLog: 'AgentOutputLog',
  MessageMetadata: 'MessageMetadata'
};

/**
 * This is a stub Prisma Client that will error at runtime if called.
 */
class PrismaClient {
  constructor() {
    return new Proxy(this, {
      get(target, prop) {
        let message
        const runtime = getRuntime()
        if (runtime.isEdge) {
          message = `PrismaClient is not configured to run in ${runtime.prettyName}. In order to run Prisma Client on edge runtime, either:
- Use Prisma Accelerate: https://pris.ly/d/accelerate
- Use Driver Adapters: https://pris.ly/d/driver-adapters
`;
        } else {
          message = 'PrismaClient is unable to run in this browser environment, or has been bundled for the browser (running in `' + runtime.prettyName + '`).'
        }
        
        message += `
If this is unexpected, please open an issue: https://pris.ly/prisma-prisma-bug-report`

        throw new Error(message)
      }
    })
  }
}

exports.PrismaClient = PrismaClient

Object.assign(exports, Prisma)
